import { t } from 'utilities/lang';

export const LOGIN = t('route.login');
export const SIGNUP = t('route.signup');

export const HOME = t('route.home');

// Staff
export const STAFF_SET_PASSOWRD = t('route.staff_set_password');
// User
export const TEAM = t('route.team');
export const PROFILE = t('route.profile');
export const ACCOUNT_DASHBOARD = t('route.account_dashboard');
export const CHANGE_PASSWORD = t('route.change_password');
export const EDIT_POLITICAL_DISCLAIMER = t('route.edit_political_disclaimer');
export const WALLET = t('route.wallet');
export const PAYMENT_METHOD = t('route.payment_method');

export const LIBRARY = t('route.library');
export const ADVERTISERS = t('route.advertisers');
export const AUDIENCES = t('route.audiences');
export const CREATE_AUDIENCES = t('route.create_audience');
export const EDIT_AUDIENCES = t('route.edit_audience');

export const CREATE_PERSONAL_DATA_TARGETING = t('route.create_personal_data_targeting');
export const CREATIVES = t('route.creatives');
export const EDIT_CREATIVES = t('route.edit_creative');

export const UPLOAD_CREATIVES = t('route.upload_creatives');

export const MY_LIBRARY = t('route.my_library');
export const CREATE_CREATIVE = t('route.create_creative');
export const STORE_TEMPLATE = t('route.store_template');
export const STORE_TEMPLATE_DETAIL = t('route.store_template_detail');

export const PURCHASED_TEMPLATE = t('route.purchased_template');

export const SUPPORT = t('route.support');

export const CAMPAIGN = t('route.campaign');
export const CREATE_CAMPAIGN = t('route.create_campaign');
export const CAMPAIGN_REVIEW = t('route.campaign_review');

export const STARTED_PAGE = t('route.started_page');
export const ANALYTICS = t('route.analytics');
